module.exports = "<select class=\"m_selectpicker form-control\" #select\n[attr.data-live-search]=\"live\" [attr.data-none-results-text]=\"texts.notFound\"\n[attr.data-none-selected-text]=\"texts.none\"\n>\n    <option *ngFor=\"let element of elements\">\n        {{element}}\n    </option>\n</select>"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/select/select.component.html
// module id = ../../../../../src/app/shared/select/select.component.html
// module chunks = main